import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_6 = {
  class: "modal",
  style: {"width":"1020px"}
}
const _hoisted_7 = { class: "modal__content pa-1" }
const _hoisted_8 = { class: "stepper--bar" }
const _hoisted_9 = { class: "stepper--bar__header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Upload Service Titan File", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "2", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Submit", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "pa--y-1 pa--left-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Upload Service Titan"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_18 = { class: "form-field form-field__standard ma--top-1" }
const _hoisted_19 = { class: "form-field__control" }
const _hoisted_20 = {
  type: "file",
  class: "form-field__input",
  ref: "upload"
}
const _hoisted_21 = { class: "form-field form-field__outline--control ma--x-1" }
const _hoisted_22 = { class: "form-checkbox" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-size":"small","color":"gray"},
  for: "isStartSubscriptionImmediately"
}, "Dry Run", -1)
const _hoisted_24 = { style: {"font-size":"80%"} }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"80%"} }, "Template screenshot(below)", -1)
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 1,
                })
              }, _hoisted_12, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 2,
                })
              }, _hoisted_15, 2)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-1", {
                'label--active': _ctx.stepper == 1,
              }])
          }, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("input", _hoisted_20, null, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDryRun) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.isDryRun]
                  ]),
                  _hoisted_23
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", {
                  href: _ctx.templateUrl,
                  download: "template.csv"
                }, "Download Template", 8, _hoisted_25)
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("img", { src: _ctx.templateImage }, null, 8, _hoisted_27)
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-3", {
                'label--active': _ctx.stepper == 2,
              }])
          }, null, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn--secontary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, " Cancel "),
        (_ctx.stepper != 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn--secontary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stepper = 1))
            }, " Back "))
          : _createCommentVNode("", true),
        (_ctx.stepper == 1 )
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.proceed2 && _ctx.proceed2(...args)))
            }, " Proceed "))
          : (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.processServiceTitan && _ctx.processServiceTitan(...args)))
            }, " Submit "))
      ])
    ])
  ]))
}